export const environment = {
  apiUrl: 'https://pms.cisautomation.net/api',
  socketUrl: 'https://pms.cisautomation.net'
};
